import React, { useState } from "react";

import { useNavigate, Link } from "react-router-dom";

import { useNotifications } from "../../context/NotificationContext";

const NotificationBell = () => {
  const navigate = useNavigate();

  const { notifications, unreadCount, markAsRead, markAllRead } =
    useNotifications();
  console.log(notifications, "load notification data");

  const [open, setOpen] = useState(false);

  const handleClick = async (notification) => {
    if (Number(notification.is_read) === 0) {
      await markAsRead(notification.id);
    }

    if (notification.url) {
      navigate(notification.url);
    }

    setOpen(false);
  };

  return (
    <>
      <button
        onClick={() => setOpen(!open)}
        className="dropdown-toggle relative"
        id="notification"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {unreadCount > 0 && (
          <span className="noti_numbering">
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
        {/* <span className="noti_numbering">10</span> */}
        {/* <span className="noti_numbering"></span> */}
        <div className="bell" id="bell-1">
          <div className="anchor material-icons layer-1">
            notifications_active
          </div>
          <div className="anchor material-icons layer-2">notifications</div>
          <div className="anchor material-icons layer-3">notifications</div>
        </div>
      </button>
      {/* <ul
        className="dropdown-menu notification-list shadow"
        aria-labelledby="notification"
      >
        <li className="notification_header">Notification </li>
        <li className="notification-message">
          {notifications.length === 0 ? (
            <li className="notification_empty">
              <img alt="" src="assets/images/empty.jpg" />
              <h3>No Notification Yet</h3>
              <p>You have no notification right Now.</p>
            </li>
          ) : (
            notifications.map((notification) => (
              <a
                key={notification.id}
                href="#"
                onClick={() => handleClick(notification)}
                style={{
                  background:
                    Number(notification.is_read) === 0 ? "#f0f7ff" : "#fff",
                }}
              >
                <div className="notify_list">
                  {Number(notification.is_read) === 0 ? (
                    <span className="avatar_img">
                      <img alt="" src="assets/images/m_user.png" />
                    </span>
                  ) : (
                    <i className="avatar_icon icon icon-check"></i>
                  )}
                  <div className="noti-details-content">
                    <p className="noti-details">{notification.title}</p>
                  
                    <p className="noti-time">
                      <i className="icon icon-clock mr03"></i>{" "}
                      {new Date(notification.created_at).toLocaleString()}
                    </p>
                  </div>
                </div>
              </a>
            ))
          )}
        </li>
        <li className="notification_footer">
          {unreadCount > 0 && (
            <a href="#" onClick={markAllRead}>
              View all Notifications
            </a>
          )}
        </li>
      </ul> */}
      <ul
        className="dropdown-menu notification-list shadow"
        aria-labelledby="notification"
      >
        <li className="notification_header">Notification</li>

        {notifications.length === 0 ? (
          <li className="notification_empty">
            <img alt="" src="assets/images/empty.jpg" />
            <h3>No Notification Yet</h3>
            <p>You have no notification right Now.</p>
          </li>
        ) : (
          <li className="notification-message">
            {notifications.map((notification) => (
              <button
                type="button"
                key={notification.id}
                onClick={() => handleClick(notification)}
                style={{
                  background:
                    Number(notification.is_read) === 0 ? "#f0f7ff" : "#fff",
                }}
              >
                <div className="notify_list">
                  {Number(notification.is_read) === 0 ? (
                    <span className="avatar_img">
                      <img alt="" src="assets/images/m_user.png" />
                    </span>
                  ) : (
                    <i className="avatar_icon icon icon-check"></i>
                  )}

                  <div className="noti-details-content">
                    <p className="noti-details">{notification.title}</p>

                    <p className="noti-time">
                      <i className="icon icon-clock mr03"></i>{" "}
                      {new Date(notification.created_at).toLocaleString()}
                    </p>
                  </div>
                </div>
              </button>
            ))}
          </li>
        )}

        <li className="notification_footer">
          {unreadCount > 0 && (
            <Link to="/notifications" onClick={markAllRead}>
              View all Notifications
            </Link>
          )}
        </li>
      </ul>
      {/* <li className="notification-message">
          <a href="#">
            <div className="notify_list">
              <i className="avatar_icon icon icon-check"></i>
              <div className="noti-details-content">
                <p className="noti-details">Please check your mail</p>
                <p className="noti-time">
                  <i className="icon icon-clock mr03"></i>4 mins ago
                </p>
              </div>
            </div>
          </a>
          <a href="#">
            <div className="notify_list">
              <span className="avatar_img">
                <img alt="" src="assets/images/m_user.png" />
              </span>
              <div className="noti-details-content">
                <p className="noti-details">New Employee Added..</p>
                <p className="noti-time">
                  <i className="icon icon-clock mr03"></i>6 mins ago
                </p>
              </div>
            </div>
          </a>
          <a href="#">
            <div className="notify_list">
              <i className="avatar_icon icon icon-check"></i>
              <div className="noti-details-content">
                <p className="noti-details">Your leave is approved!! </p>
                <p className="noti-time">
                  <i className="icon icon-clock mr03"></i>8 mins ago
                </p>
              </div>
            </div>
          </a>
          <a href="#">
            <div className="notify_list">
              <span className="avatar_img">
                <img alt="" src="assets/images/m_user.png" />
              </span>
              <div className="noti-details-content">
                <p className="noti-details">New Employee Added..</p>
                <p className="noti-time">
                  <i className="icon icon-clock mr03"></i>6 mins ago
                </p>
              </div>
            </div>
          </a>
          <a href="#">
            <div className="notify_list">
              <i className="avatar_icon icon icon-check"></i>
              <div className="noti-details-content">
                <p className="noti-details">Your leave is approved!! </p>
                <p className="noti-time">
                  <i className="icon icon-clock mr03"></i>8 mins ago
                </p>
              </div>
            </div>
          </a>
        </li>
        <li className="notification_footer">
          <a href="notification.html">View all Notifications</a>
        </li> */}
    </>
  );
};

export default NotificationBell;
